import gql from "graphql-tag";

export const NOMINEE_ADD_EXTERNAL_DIRECTOR_FOR_COMPANY = gql`
  mutation NomineeAddExternalDirectorForCompany($companyId: ID!) {
    nomineeAddExternalDirectorForCompany(companyId: $companyId) {
      feedback
    }
  }
`;
